export type KVCameraViewJSON = {
  cameraViewId: string
  cameraViewName: string
  cameraViewNotes: string
  cameraViewPosition: string
  cameraViewRotation: string
}

export class KVCameraView {
  id: string
  name: string
  notes: string
  cameraPosition: string
  cameraRotation: string

  constructor(id: string) {
    this.id = id
    this.name = ''
    this.notes = ''
    this.cameraPosition = ''
    this.cameraRotation = ''
  }

  static fromJSON(json: KVCameraViewJSON): KVCameraView {
    const cameraView = new KVCameraView(json.cameraViewId)
    if (json.cameraViewName) cameraView.name = json.cameraViewName
    if (json.cameraViewNotes) cameraView.notes = json.cameraViewNotes
    if (json.cameraViewPosition)
      cameraView.cameraPosition = json.cameraViewPosition
    if (json.cameraViewRotation)
      cameraView.cameraRotation = json.cameraViewRotation
    return cameraView
  }

  static toJSON(cameraView: KVCameraView): KVCameraViewJSON {
    return {
      cameraViewId: cameraView.id,
      cameraViewName: cameraView.name,
      cameraViewNotes: cameraView.notes,
      cameraViewPosition: cameraView.cameraPosition,
      cameraViewRotation: cameraView.cameraRotation,
    }
  }
}
